/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Main = function () {
	  function Main() {
	    _classCallCheck(this, Main);
	
	    // CSSPlugin.defaultForce3D = false;
	    // app.contentScale = 0.9;
	    // app.verticalScale = 0.9;
	
	    // var pers = util.getUrlVars('perspective');
	    // var deg = util.getUrlVars('rotation');
	    // var long = util.getUrlVars('shrink');
	    // var sc = $.ua =
	    // var bg = util.getUrlVars('bg');
	    // if ( pers ){
	    //   $('#stage').css({
	    //     perspective: pers + 'px'
	    //   });
	    //   $('#debug [name="perspective"]').val(pers)
	    // }
	    // if ( sc ){
	    //   app.contentScale = sc;
	    //   $('#debug [name="scale"]').val(sc)
	    // }
	    // if ( deg ){
	    //   $('#surface').css({
	    //     transform: 'rotateX('+deg+'deg)'
	    //   })
	    //   $('#debug [name="rotation"]').val(deg)
	    //   // TweenMax.set('#surface', { rotationX: 25 });
	    // }
	
	    // if ( long ){
	    //   app.verticalScale = long;
	    //   $('#debug [name="shrink"]').val(long)
	    // }
	    // if ( bg == 1 ){
	    //   $('#surface').css({
	    //     background: 'lightgray'
	    //   });
	    //   $('#debug [name="bg"]').val(bg)
	
	    // }
	
	
	    var ua = navigator.userAgent.toLowerCase();
	    app.ua = {
	      // Windows
	      isWindows: /windows/.test(ua),
	      // Mac
	      isMac: /macintosh/.test(ua),
	      // PC
	      isPC: /windows/.test(ua) || /macintosh/.test(ua) || /ipad/.test(ua),
	      // IE
	      isIE: /msie (\d+)/.test(ua) || ua.indexOf('trident/7') > -1 || /edge (\d+)/.test(ua),
	      // isIE: /macintosh/.test(ua),　//IEをmacで制限するテスト
	      // IE6
	      isIE6: /msie (\d+)/.test(ua) && RegExp.$1 == 6,
	      isIE7: /msie (\d+)/.test(ua) && RegExp.$1 == 7,
	      // IE9未満
	      isLtIE9: /msie (\d+)/.test(ua) && RegExp.$1 < 9,
	      // IE10未満
	      isLtIE10: /msie (\d+)/.test(ua) && RegExp.$1 < 10,
	      // Firefox
	      isFirefox: /firefox/.test(ua),
	      // WebKit
	      isWebKit: /applewebkit/.test(ua),
	      // タッチデバイス
	      isTouchDevice: 'ontouchstart' in window,
	      // iOS
	      isIOS: /i(phone|pod|pad)/.test(ua),
	      // iPhone、iPod touch
	      isIPhone: /i(phone|pod)/.test(ua),
	      // iPad
	      isIPad: /ipad/.test(ua),
	      // Android
	      isAndroid: /android/.test(ua),
	      // モバイル版Android
	      isAndroidMobile: /android(.+)?mobile/.test(ua),
	      isSmartPhone: /i(phone|pod)/.test(ua) || /android(.+)?mobile/.test(ua)
	    };
	    if (app.ua.isWindows) {
	      $('html').addClass('windows');
	    }
	
	    function onOrientationChange(mql) {
	      if (mql.matches) {
	        $('html').addClass('newPortrait');
	        $('html').removeClass('newLandscape');
	      } else {
	        $('html').addClass('newLandscape');
	        $('html').removeClass('newPortrait');
	      }
	    }
	    var mql = window.matchMedia("(orientation: portrait)");
	    mql.addListener(onOrientationChange);
	    onOrientationChange(mql);
	
	    $(window).on('resize', function () {
	      if (window.matchMedia('(max-width:760px)').matches) {
	        app.media = 'sp';
	        app.contentScale = 0.9;
	        app.verticalScale = 1;
	        app.parseRevise = 0.20;
	        app.topMainHeightShort = 0;
	
	        app.verticalScaleY = app.contentScale * app.verticalScale;
	      } else {
	        app.media = 'pc';
	        if (app.ua.isIE) {
	          app.contentScale = 0.7;
	          app.verticalScale = 1;
	          app.parseRevise = 0;
	          app.topMainHeightShort = 0;
	          TweenMax.set('#surface', { rotationX: 0 });
	        } else {
	          app.contentScale = 0.7;
	          app.verticalScale = 1;
	          app.parseRevise = 0.3;
	          app.topMainHeightShort = 0;
	        }
	        app.verticalScaleY = app.contentScale * app.verticalScale;
	      }
	    });
	    $(window).resize();
	
	    if (!app.$tempPersonDetailMain) {
	      app.$tempPersonDetailMain = $($('#tempPersonDetailMain').remove().text());
	    }
	
	    if (!app.$tempOtherPeople) {
	      app.$tempOtherPeople = $($('#tempOtherPeople').remove().text());
	    }
	
	    app.personsArr = this.createPersonArr();
	
	    app.modals = new Modals();
	    app.modals.news = new News('news');
	    app.modals.welfare = new Welfare('welfare');
	    app.modals.modalContact = new ModalContact('modalContact');
	    app.modals.entry = new Entry('entry');
	    app.modals.detail = new Detail('detail');
	
	    //topページ専用
	    if ($('body').is('.index')) {
	      app.top = new Top();
	      if (location.href.indexOf('192.168') != -1) {
	        TweenMax.to('#loading,#intro', 0.1, { autoAlpha: 0 });
	        app.top.start();
	      } else {
	        var $progress = $('#loading .progress');
	        // app.top.start();
	        $('#wrapper').imagesLoaded().always(function (instance) {
	          // console.log('always');
	          new TimelineMax().to({}, 1, {}).to('#intro,#loading', 0.5, { autoAlpha: 0 }).add(function () {
	            app.top.start();
	          });
	        }).done(function (instance) {
	          // console.log('all images successfully loaded');
	        }).fail(function () {
	          // console.log('all images loaded, at least one is broken');
	        }).progress(function (instance, image) {
	          var per = 100 - Math.floor(instance.progressedCount / instance.images.length * 100);
	          TweenMax.to($progress, 0.5, { x: -per + '%', ease: Power0.easeInOut });
	        });
	      }
	    } else {}
	    // TweenMax.to('#loading', 0.1, { autoAlpha: 0 });
	
	
	    // リクルート詳細ページ
	    if ($('body').is('.recruitDetail')) {
	      this.persons = app.personsArr;
	      var otherPeoples = [];
	      $.each(this.persons, function (i, el) {
	        // console.log(el.otherPeople());;
	        if (el.id == '00') {
	          return;
	        }
	        var cont = el.otherPeople();
	        otherPeoples.push(cont);
	      });
	      $('#recruitOtherPeople').html(otherPeoples);
	
	      this.slider = $('#recruitOtherPeople').slick({
	        appendArrows: $('#recruitOtherPeople'),
	        prevArrow: '<div class="arrow prev"></div>',
	        nextArrow: '<div class="arrow next"></div>',
	        infinite: true,
	        slidesToShow: 4,
	        slidesToScroll: 4,
	        arrows: true,
	        draggable: false,
	        centerPadding: 0,
	        responsive: [{
	          breakpoint: 760,
	          settings: {
	            infinite: true,
	            speed: 200,
	            // centerMode: true
	            // centerPadding: 0,
	            draggable: true,
	            slidesToShow: 4,
	            slidesToScroll: 1,
	            swipeToSlide: true,
	            arrows: false
	          }
	        }]
	      });
	    }
	
	    // sp用メニュー
	    var $trigger = $('#menuTrigger');
	    $trigger.on({
	      click: function click() {
	        if ($trigger.is('.open')) {
	          $trigger.removeClass('open');
	        } else {
	          $trigger.addClass('open');
	        }
	      }
	    });
	
	    var $gloabalNav = $('#globalNav li');
	    $gloabalNav.on({
	      click: function click() {
	        $trigger.removeClass('open');
	      }
	    });
	  }
	
	  _createClass(Main, [{
	    key: 'createPersonArr',
	    value: function createPersonArr() {
	      var data = app.data;
	      var positions = app.positions;
	      var monstterId = '00';
	      var ceoId = '02';
	
	      //ドラゴンを取り出す
	      var monster = _.find(data, function (obj) {
	        return obj.id == monstterId;
	      });
	      //ceoを取り出す
	      var ceo = _.find(data, function (obj) {
	        return obj.id == ceoId;
	      });
	      // 2人を除いた配列を生成
	      data = _.filter(data, function (obj) {
	        return obj.id != monstterId && obj.id != ceoId;
	      });
	
	      // 人をグループごとに分けてシャッフル
	      var personGroupL = _.where(data, { group: 'left' });
	      personGroupL = _.shuffle(personGroupL);
	      var personGroupR = _.where(data, { group: 'right' });
	      personGroupR = _.shuffle(personGroupR);
	
	      // 辞めた人を補充するために配列を2重に
	      personGroupR = personGroupR.concat(personGroupR);
	      personGroupL = personGroupL.concat(personGroupL);
	
	      // monsterとceoを重複させないため最後に追加
	      // monsterを所定の位置に
	      personGroupR.splice(2, 0, monster);
	      //ceoを所定の位置に
	      personGroupL.splice(11, 0, ceo);
	
	      // 場所を左右に分ける
	      var posGroupL = _.filter(positions, function (obj) {
	        return obj.rev == true;
	      });
	      var posGroupR = _.filter(positions, function (obj) {
	        return obj.rev == false;
	      });
	
	      // 人グループを場所具クループの数とあわせる
	      personGroupL = personGroupL.slice(0, posGroupL.length);
	      personGroupR = personGroupR.slice(0, posGroupR.length);
	
	      // 人と場所を左右それぞれで統合
	      var groupL = _.map(posGroupL, function (element, index, array) {
	        return _.extend(element, personGroupL[index]);
	      });
	      var groupR = _.map(posGroupR, function (element, index, array) {
	        return _.extend(element, personGroupR[index]);
	      });
	      //グループを統合
	      var group = groupL.concat(groupR);
	      // 高さ順にソート
	      this.data = _.sortBy(group, function (item) {
	        return item.order;
	      });
	
	      // console.log(this.width, this.height);
	      this.persons = [];
	      for (var i = 0; i < this.data.length; i++) {
	        var data = this.data[i];
	        data.index = i;
	        this.person = new Person(data);
	        // this.person.defaultTop = this.person.top;
	        this.persons.push(this.person);
	      }
	      return this.persons;
	    }
	  }]);
	
	  return Main;
	}();
	
	var Top = function () {
	  function Top() {
	    var _this = this;
	
	    _classCallCheck(this, Top);
	
	    //人物データを読み込み
	    this.persons = app.personsArr;
	
	    //カスタムスクロールバーを読み込み
	    if (app.ua.isPC && !app.ua.isIE) {
	      this.scrollBar = new ScrollBar('#surface');
	    }
	    //リサイズ時の挙動
	    this.$surface = $('#surface');
	    this.scale = 1;
	
	    this.fisSize();
	
	    $(window).on({
	      resize: function resize() {
	        //サイズを更新
	        TweenMax.set('#main', { height: (util.win.h - app.topMainHeightShort) / app.verticalScaleY - util.win.h * app.parseRevise });
	        TweenMax.set('#stage .content', { scaleX: app.contentScale, scaleY: app.verticalScaleY });
	        // 画面の位置を微妙に調整
	        _this.fisSize();
	
	        _this.width = $(window).width(); //$('.content .inner').width();
	        _this.height = $('.content').get(0).clientHeight; //$('.content .inner').get(0).style.height;
	
	        if (app.ua.isIE) {
	          TweenMax.set('#surface', { width: '100%', left: 0 });
	          TweenMax.set('#scroller', { overflow: 'hidden', height: _this.height * app.verticalScaleY });
	        }
	
	        _this.update();
	
	        clearTimeout(_this.timer);
	        _this.timer = setTimeout(function () {
	
	          if (app.ua.isPC && !app.ua.isIE) {
	            _this.scrollBar.resize(_this.height, _this.$surface.scrollTop(), _this.scale);
	          }
	          if (app.media == 'pc') {
	            $('#mapLink').attr({
	              href: 'https://goo.gl/maps/mq9a7Au3hH72'
	            }).text('Google Mapで見る');
	          } else {
	            $('#mapLink').attr({
	              href: 'http://maps.apple.com/?q=35.655173, 139.694999'
	            }).text('Map Appで見る');
	          }
	        }, 1000);
	      }
	    });
	
	    $.ajax('/news/').done(function (data) {
	      $('#newsIndex').find('.thumbList').append(data);
	
	      //暫定moreボタン
	      var newsHeight = $('#newsIndex').find('.thumbList').get(0).clientHeight;
	      $('#newsIndex').find('li').each(function (i, el) {
	        var t = $(el).get(0).offsetTop;
	
	        if (i == 2) {
	          $('.thumbList').height(t);
	          return false;
	        }
	      });
	      $('#newsIndex').find('.more').on({
	        click: function click(e) {
	          TweenMax.to(e.currentTarget, 0.5, { autoAlpha: 0 });
	          TweenMax.to($('#newsIndex').find('.thumbList'), 0.5, { height: newsHeight,
	            // onUpdate: ()=>{
	            //   $(window).resize();
	            // },
	            onComplete: function onComplete() {
	              $(window).resize();
	            }
	          });
	          // $(e.currentTarget).
	        }
	      });
	
	      $('#newsIndex').find('li a').on({
	        click: function click(e) {
	          var postId = $(e.currentTarget).data('postid');
	          app.modals.news.setContent(postId);
	          app.modals.open('news');
	          return false;
	        }
	      });
	      $(window).resize();
	    }).fail(function (err) {
	      console.log(err);
	    });
	
	    this.graphs = [];
	    $.each($('.graph'), function (i, el) {
	      var graph = new Graph('graph' + (i + 1));
	      _this.graphs.push(graph);
	    });
	
	    var view, relative, min, max, offset, reference, pressed, xform, velocity, frame, timestamp, ticker, amplitude, target, timeConstant;
	
	    function ypos(e) {
	      // touch event
	      if (e.targetTouches && e.targetTouches.length >= 1) {
	        return e.targetTouches[0].clientY;
	      }
	
	      // mouse event
	      return e.clientY;
	    }
	
	    var scroll = function scroll(y) {
	      // console.log(y, max, min);
	      // offset = $(view).scrollTop();
	
	      _this.offset = y > max ? max : y < min ? min : y;
	      $(view).scrollTop(_this.offset);
	      // view.style[xform] = 'translateY(' + (-this.offset) + 'px)';
	    };
	
	    var track = function track() {
	      var now, elapsed, delta, v;
	
	      now = Date.now();
	      elapsed = now - timestamp;
	      timestamp = now;
	      delta = _this.offset - frame;
	      frame = _this.offset;
	
	      v = 1000 * delta / (1 + elapsed);
	      velocity = 0.8 * v + 0.2 * velocity;
	    };
	
	    var autoScroll = function autoScroll() {
	      var elapsed, delta;
	
	      if (amplitude) {
	        elapsed = Date.now() - timestamp;
	        delta = -amplitude * Math.exp(-elapsed / timeConstant);
	        if (delta > 0.5 || delta < -0.5) {
	          scroll(target + delta);
	          requestAnimationFrame(autoScroll);
	        } else {
	          scroll(target);
	        }
	      }
	    };
	
	    var tap = function tap(e) {
	      pressed = true;
	      reference = ypos(e);
	
	      velocity = amplitude = 0;
	      frame = _this.offset;
	      timestamp = Date.now();
	      clearInterval(ticker);
	      ticker = setInterval(track, 100);
	
	      // e.preventDefault();
	      e.stopPropagation();
	      // return false;
	    };
	
	    var drag = function drag(e) {
	      var y, delta;
	      if (pressed) {
	        y = ypos(e);
	        delta = reference - y;
	        if (delta > 2 || delta < -2) {
	          reference = y;
	          scroll(_this.offset + delta);
	        }
	      }
	      // e.preventDefault();
	      e.stopPropagation();
	      // return false;
	    };
	
	    var release = function release(e) {
	      pressed = false;
	
	      clearInterval(ticker);
	      if (velocity > 10 || velocity < -10) {
	        amplitude = 0.8 * velocity;
	        target = Math.round(_this.offset + amplitude);
	        timestamp = Date.now();
	        requestAnimationFrame(autoScroll);
	      }
	
	      // e.preventDefault();
	      e.stopPropagation();
	      // return false;
	    };
	
	    view = this.$surface.get(0);
	
	    this.$surface.on({
	      touchstart: function touchstart(e) {
	        _this.startY = e.targetTouches[0].pageY;
	        tap(e);
	      },
	      touchmove: function touchmove(e) {
	        _this.moveY = e.targetTouches[0].pageY;
	        // var scrTop = this.$surface.scrollTop();
	        var scrTop = _this.offset;
	        max = _this.height * app.verticalScaleY - util.win.h / _this.scale;
	
	        if (scrTop <= 0 && _this.startY < _this.moveY) {
	          return false;
	        }
	        if (scrTop + 10 > _this.height * app.verticalScaleY - util.win.h / _this.scale && _this.startY > _this.moveY) {
	          return false;
	        }
	        drag(e);
	      },
	      touchend: function touchend(e) {
	        release(e);
	      },
	      scroll: function scroll(e) {
	        // console.log("scroll");
	        var scrTop = _this.offset = _this.$surface.scrollTop();
	        // var scrTop = this.offset;
	        scrTop = Math.max(scrTop, 0);
	        scrTop = Math.min(scrTop + 10, _this.height * app.verticalScaleY - util.win.h / _this.scale);
	        if (scrTop != _this.exScrTop) {
	          $.each(_this.persons, function (i, person) {
	            person.update();
	            person.walkTl.pause();
	          });
	          $.each(_this.graphs, function (i, graph) {
	            graph.update();
	            graph.tl.pause();
	          });
	
	          if (app.media == 'pc') {
	            _this.scrollBar.update(scrTop);
	          }
	          _this.exScrTop = scrTop;
	        }
	      }
	    });
	    max = $('.content').get(0).clientHeight;
	    this.offset = min = 0;
	    pressed = false;
	    timeConstant = 325; // ms
	
	
	    // this.ticker = new Ticker();
	    // this.ticker.move();
	
	    // トップページを生成
	    // scene情報を生成
	    app.scenes = [];
	    $.each($('.scene'), function (i, scene) {
	      var o = {
	        el: scene,
	        id: $(scene).attr('id'),
	        height: scene.clientHeight,
	        top: scene.offsetTop
	      };
	      app.scenes.push(o);
	    });
	
	    // console.log("resize");
	    $(window).resize();
	  }
	
	  _createClass(Top, [{
	    key: 'fisSize',
	    value: function fisSize() {
	      TweenMax.set(this.$surface, { scale: 1 });
	      var surfaceH = this.$surface.outerHeight();
	      //scale前の値を割り出す
	      var h = surfaceH;
	      // 新しいscaleで上書き
	      this.scale = util.win.h / h;
	      // surfaceをscale
	      TweenMax.set(this.$surface, { scale: this.scale });
	      TweenMax.set('#stage', { y: 0 });
	      var off = $('#stage').data('offset');
	      var t = this.$surface.position().top + off * 2;
	      TweenMax.set('#stage', { y: -t });
	      $('#stage').attr('data-offset', t);
	      // console.log(util.win.h , app.topMainHeightShort  , app.parseRevise );
	      TweenMax.set('#scroller .inner', { paddingTop: (util.win.h - app.topMainHeightShort) * app.parseRevise });
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      //リファラーを取得
	      var referrer = document.referrer;
	      this.isInternal = /grenge.co.jp/.test(referrer);
	
	      var hash = location.href.split('#/')[1];
	      if (hash) {
	        this.introSkip();
	        // setTimeout( ()=> {
	        util.smoothScroll.toAnchor('#' + hash);
	        // },1000);
	      } else if (this.isInternal) {
	        this.introSkip();
	      } else {
	        this.introTl.play(0);
	      }
	
	      //初回表示分をアップデート
	    }
	  }, {
	    key: 'createTimeline',
	    value: function createTimeline() {
	      var _this2 = this;
	
	      $.each(this.persons, function (i, person) {
	        // シーン情報取得
	        var parent = _.find(app.scenes, function (el) {
	          if (el.id == person.parent) {
	            return el;
	          }
	        });
	        // シーンに応じて配置方法を変更
	        if (person.parent == 'main') {
	          // .mainのみ高さが可変なのでパーセントで配置
	          if ($.isArray(person.defaultTop)) {
	            if (app.media == 'pc') {
	              person.top = parent.height * person.defaultTop[0];
	            } else {
	              person.top = parent.height * person.defaultTop[1];
	            }
	            // console.log(person.defaultTop);
	          } else {
	            person.top = parent.height * person.defaultTop;
	          }
	        }
	        if (app.ua.isIE) {
	          TweenMax.set(person.$obj, { x: person.left, top: person.top });
	        } else {
	          TweenMax.set(person.$obj, { x: person.left, top: person.top, skewX: -person.per });
	        }
	        TweenMax.set(person.$obj.find('.person'), { rotationY: person.direction });
	        // それぞれシーンに配置
	        var $personsWrapper = _this2.$surface.find('#' + person.parent + ' .persons');
	        $personsWrapper.append(person.$obj);
	        // アップデート
	        person.createTimeline();
	        person.update();
	
	        $.each(_this2.graphs, function (i, graph) {
	          graph.createTimeline();
	          graph.update();
	        });
	      });
	
	      // イントロ用のタイムライン
	      this.introOffsetY = 2000;
	      TweenMax.set('#scroller', { y: this.introOffsetY });
	      this.introTl = new TimelineMax({
	        paused: true,
	        onStart: function onStart() {
	          for (var i = 0; i < 8; i++) {
	            _this2.persons[i].walkTl.progress(0, false);
	          }
	        },
	        onComplete: function onComplete() {
	          _this2.introViewd = true;
	        }
	      })
	      // .to('#intro h2', 1, { autoAlpha: 1 })
	      // .to({},1,{})
	
	      .to(this, 2, { introOffsetY: 0, ease: Power2.easeOut,
	        onUpdate: function onUpdate() {
	          TweenMax.set('#scroller', { y: _this2.introOffsetY });
	        }
	      }).add(function () {
	        for (var i = 0; i < 8; i++) {
	          _this2.persons[i].walkTl.duration(3);
	          _this2.persons[i].walkTl.play(0);
	        }
	      }, '-=0.3');
	
	      // 条件によって再生させるかを決める
	      if (this.introViewd == true) {
	        this.introSkip();
	      }
	      // this.introTl.stop().progress(1,false);
	      // console.log("create");
	    }
	  }, {
	    key: 'introSkip',
	    value: function introSkip() {
	      // console.log("vieed");
	      // イントロを閲覧後はアニメーションを表示させない
	      this.introTl.stop().progress(1, false);
	      for (var i = 0; i < 8; i++) {
	        this.persons[i].walkTl.progress(1, false);
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      // 各sceneのサイズをアップデート
	      $.each(app.scenes, function (i, scene) {
	        scene.height = scene.el.clientHeight;
	        scene.top = scene.el.offsetTop;
	      });
	      // タイムラインを作りなおし
	      this.createTimeline();
	    }
	  }]);
	
	  return Top;
	}();
	
	var Graph = function () {
	  function Graph(id) {
	    _classCallCheck(this, Graph);
	
	    this.id = id;
	    this.$container = $('#' + id);
	    this.$img = this.$container.find('img');
	
	    // this.createTimeline();
	  }
	
	  _createClass(Graph, [{
	    key: 'createTimeline',
	    value: function createTimeline() {
	      var recruit = _.find(app.scenes, function (el) {
	        if (el.id == 'recruit') {
	          return el;
	        }
	      });
	      this.top = this.$container.get(0).offsetTop + recruit.top;
	      // console.log('top'+this.top);
	      this.$surface = $('#surface');
	
	      this.tl = new TimelineMax({
	        paused: true
	      }).to({}, this.top - util.win.h / app.verticalScaleY + 100, {}).fromTo(this.$img, util.win.h / app.verticalScaleY / 2, { x: 0 }, { x: -590 * 9, ease: SteppedEase.config(9) });
	      // console.log('top:' ,this.top-(util.win.h/app.verticalScaleY));
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var scTop = this.$surface.scrollTop() / app.verticalScaleY;
	      if (scTop > this.top - util.win.h / app.verticalScaleY && scTop < this.tl.totalDuration()) {
	        this.tl.seek(Math.ceil(Math.max(0, scTop)), false);
	      } else if (scTop > this.tl.totalDuration()) {
	        this.tl.progress(1, false);
	      } else {
	        this.tl.progress(0, false);
	      }
	    }
	  }]);
	
	  return Graph;
	}();
	
	var Person = function () {
	  function Person(data) {
	    var _this3 = this;
	
	    _classCallCheck(this, Person);
	
	    this.width = 170;
	    this.id = data.id;
	    this.scale = 1.3;
	    $.extend(this, data);
	    // console.log(this);
	    // this.rev = this.left > 0 ? true : false;
	    this.left = data.left - this.width / 2;
	    // console.log(this.left, this.order);
	    // this.per = (this.left/util.win.w*100) - 50;
	    this.per = data.left / 40;
	    this.direction = this.rev ? 180 : 0;
	    this.scrSync = data.scrSync;
	    // var num = ('0'+(Math.floor(Math.random()*13)+1)).slice(-2);
	    // if ( this.id > '18' || this.id == '01' || this.id == '16' ){
	    //   this.id = 18;
	    // }
	    var num = this.id;
	    var tmp = '<div id="id' + data.id + '" class="object">\n      <div class="person">\n        <div class="sprite">\n          <img class="body" src="/assets/img/person/thumb/' + num + '_walk.png" alt="">\n          <img class="shadow" src="/assets/img/person/thumb/' + num + '_walk_s.png" alt="">\n        </div>\n      </div>\n      <a href="#" class="area">\n        <div class="tapus">\n          <img src="/assets/img/txt_tapus.png" alt="" />\n        </div>\n      </div>\n    </div>';
	    // <div class="shadow"><img src="/assets/img/person/shadow.png" alt="" /></div>
	    this.$obj = $(tmp);
	    this.$objPerson = this.$obj.find('.person');
	    // console.log(data.rev);
	    this.message = '<section id="message">\n                    <p>\u30B0\u30EC\u30F3\u30B8\u306F\u53CB\u4EBA\u3068\u306E\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3092<br>\u8EF8\u3068\u3057\u305F\u30BD\u30FC\u30B7\u30E3\u30EB\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E<br>\u4F01\u753B\u30FB\u958B\u767A\u3092\u3059\u308B\u4F1A\u793E\u3067\u3059\u3002</p>\n                    <p>\u30BD\u30FC\u30B7\u30E3\u30EB\u3068\u3044\u3046\u30EF\u30FC\u30C9\u306F<br>\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306E\u696D\u754C\u306B\u304A\u3044\u3066<br>\u6D41\u884C\u8A9E\u306E\u3088\u3046\u306B\u8A9E\u3089\u308C\u3066\u3044\u307E\u3059\u304C\u3001<br>\u305D\u306E\u672C\u8CEA\u306F\u4EBA\u9593\u306E\u6839\u6E90\u7684\u306A\u6B32\u6C42\u306B<br>\u57FA\u3065\u3044\u305F\u3082\u306E\u3067\u3042\u308A\u3001<br>\u666E\u904D\u7684\u306A\u3082\u306E\u3060\u3068\u601D\u3044\u307E\u3059\u3002</p>\n                    <p>\u4EBA\u306F\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u306A\u3057\u3067\u306F<br>\u751F\u304D\u3066\u3044\u3051\u307E\u305B\u3093\u3002</p>\n                    <p>\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u304D\u3063\u304B\u3051\u306F<br>\u4EBA\u306E\u611F\u60C5\u3067\u3042\u308A\u3001<br>\u611F\u60C5\u306B\u57FA\u3065\u3044\u3066\u8A2D\u8A08\u3055\u308C\u305F<br>\u30BD\u30FC\u30B7\u30E3\u30EB\u30E1\u30C7\u30A3\u30A2\u306E\u767A\u5C55\u306F<br>\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306E\u6301\u3064\u4FA1\u5024\u3092<br>\u60C5\u5831\u304B\u3089\u5171\u611F\u3078\u3068\u30B7\u30D5\u30C8\u3055\u305B\u3066\u3044\u307E\u3059\u3002</p>\n                    <p>\u6211\u3005\u30B0\u30EC\u30F3\u30B8\u306F\u3001<br>\u3053\u306E\u30D1\u30E9\u30C0\u30A4\u30E0\u30B7\u30D5\u30C8\u3092<br>\u7D76\u597D\u306E\u30C1\u30E3\u30F3\u30B9\u3068\u3068\u3089\u3048\u3001<br>\u4E16\u754C\u4E2D\u306E\u4EBA\u305F\u3061\u304C\u4F7F\u3046\u3088\u3046\u306A<br>\u30B5\u30FC\u30D3\u30B9\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u308A\u305F\u3044\u3068<br>\u672C\u6C17\u3067\u8003\u3048\u3066\u3044\u307E\u3059\u3002</p>\n                   </section>';
	
	    // TweenMax.set('#persons', { height: $('.content').get(0).clientHeight });
	    this.$tempPersonDetailMain = app.$tempPersonDetailMain.clone();
	    this.$tempOtherPeople = app.$tempOtherPeople.clone();
	
	    this.$surface = $('#surface');
	
	    this.minPersonH = 85; // パーセント
	    this.maxPersonH = 145; // パーセント
	    this.rangeParsonH = this.maxPersonH - this.minPersonH;
	    // this.$surface.on({
	    //   scroll: ()=>{
	    //     this.update();
	    //   }
	    // });
	    this.$obj.find('.area').on({
	      mouseenter: function mouseenter() {
	        _this3.$obj.find('.person').addClass('hover');
	      },
	      mouseleave: function mouseleave() {
	        _this3.$obj.find('.person').removeClass('hover');
	      },
	      click: function click() {
	
	        if (_this3.id == '00') {
	          util.smoothScroll.toAnchor('#product');
	          return;
	        }
	        if (app.modals.isOpen) {
	          _this3.change();
	        } else {
	          _this3.setDetailPage();
	          app.modals.open('detail');
	          app.modals.$inner.scrollTop(0);
	        }
	        return false;
	      }
	    });
	
	    this.createDetail();
	  }
	
	  _createClass(Person, [{
	    key: 'change',
	    value: function change() {
	      var _this4 = this;
	
	      this.changeTl = new TimelineMax().to(app.modals.detail.$container, 0.3, { autoAlpha: 0 }).add(function () {
	        _this4.setDetailPage();
	      }).to(app.modals.detail.$container, 0.3, { autoAlpha: 1 });
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var scTop = this.$surface.scrollTop() / app.verticalScaleY;
	      var posTop = this.scene.top + this.top - scTop;
	      // console.log(scTop);
	      // console.log(posTop);
	      // console.log(util.win.h );
	      if (posTop > -300 && posTop < util.win.h / app.verticalScaleY + 300) {
	        // 300は画面外の分
	        TweenMax.set(this.$obj, { display: 'block' });
	        var unit = posTop / (util.win.h / app.verticalScaleY) * this.rangeParsonH;
	        var scalePercent = (this.minPersonH - unit + this.rangeParsonH) / app.verticalScale;
	        // console.log(scalePercent);
	        // console.log(scalePercent/100);
	
	        if (app.ua.isIE) {
	          TweenMax.set(this.$obj, { scale: this.scale });
	        } else {
	          TweenMax.set(this.$obj, { scaleY: scalePercent / 100 * this.scale, scaleX: this.scale });
	        }
	        this.additionalDirection;
	        if (this.scrSync == true) {
	          var additionalDirection = scTop > this.exScTop ? 0 : 180;
	          if (scTop < this.walkTl.totalDuration()) {
	            // TweenMax.set(this.$obj, { rotationY: this.direction + additionalDirection  });
	
	            // console.log(this.id, scTop);
	            this.walkTl.seek(Math.ceil(Math.max(0, scTop)), false);
	            TweenMax.set(this.$objPerson, { rotationY: this.direction + additionalDirection });
	          } else {
	
	            this.walkTl.progress(1, false);
	            TweenMax.set(this.$objPerson, { rotationY: this.direction });
	          }
	        } else {
	          var additionalDirection = scTop > this.exScTop ? 180 : 0;
	          if (scTop < this.walkTl.totalDuration() && scTop > 0) {
	            // console.log("範囲内");
	            // TweenMax.set(this.$obj, { rotationY: this.direction + additionalDirection  });
	
	            // console.log(this.id, scTop);
	            this.walkTl.seek(Math.ceil(Math.max(0, this.walkTl.totalDuration() - scTop)), false);
	            TweenMax.set(this.$objPerson, { rotationY: this.direction + additionalDirection });
	          } else if (scTop <= 0) {
	            this.walkTl.progress(1, false);
	            TweenMax.set(this.$objPerson, { rotationY: this.direction });
	            // TweenMax.set(this.$objPerson, { rotationY: this.direction });
	          } else {
	            this.walkTl.progress(0, false);
	          }
	        }
	
	        this.exScTop = scTop;
	      } else {
	        TweenMax.set(this.$obj, { display: 'none' });
	      }
	    }
	  }, {
	    key: 'createTimeline',
	    value: function createTimeline() {
	      var _this5 = this;
	
	      this.scene = _.find(app.scenes, function (el) {
	        if (el.id == _this5.parent) {
	          return el;
	        }
	      });
	
	      this.tapusSwingTl = new TimelineMax({
	        paused: true
	      }).fromTo(this.$obj.find('.tapus'), 0.5, { rotation: 0 }, { rotation: -5, repeat: -1, yoyo: true, ease: SteppedEase.config(1) }, 0);
	
	      this.tapusTl = new TimelineMax({
	        paused: true
	      }).fromTo(this.$obj.find('.tapus'), 0.2, { scale: 0, x: '-50%' }, { scale: 0.75, ease: Back.easeOut });
	
	      this.move = 850 * (this.rev ? -1 : 1);
	      this.stepPattern = 4; // 変更しない
	      this.stepRepeat = 3;
	      this.stepDelay = 50;
	      // this.walkStartOffset = 300;
	      this.walkStartOffset = this.order == 33 || this.order == 34 ? 500 : 300;
	
	      this.walkTl = new TimelineMax({
	        paused: true
	      })
	      // .to({},Math.min(this.top - util.win.h, util.win.h), {})
	      .to({}, this.scene.top + this.top - util.win.h / app.verticalScaleY - this.walkStartOffset, {}).add('move');
	      //pcの時にはfadein
	      if (app.media == 'pc') {
	        this.walkTl
	        // .set(this.$obj,{ autoAlpha: 1})
	        .fromTo(this.$obj, 300, { autoAlpha: 0 }, { autoAlpha: 1 }, 'move');
	      } else {
	        this.walkTl.set(this.$obj, { autoAlpha: 1 });
	      }
	
	      if (app.ua.isIE) {
	        this.walkTl.fromTo(this.$obj, this.stepPattern * this.stepRepeat * this.stepDelay, { x: this.left + this.move }, { x: this.left, ease: SteppedEase.config(this.stepPattern * this.stepRepeat - 1) }, 'move');
	      } else {
	        this.walkTl.fromTo(this.$obj, this.stepPattern * this.stepRepeat * this.stepDelay, { x: this.left + this.move, skewX: -((this.left + this.move + this.width / 2) / 50) }, { x: this.left, skewX: -((this.left + this.width / 2) / 50), ease: SteppedEase.config(this.stepPattern * this.stepRepeat - 1) }, 'move');
	      }
	
	      this.walkTl.fromTo(this.$obj.find('.sprite'), this.stepPattern * this.stepDelay, { x: -this.width }, { x: -this.width * this.stepPattern, ease: SteppedEase.config(this.stepPattern - 1), repeat: this.stepRepeat - 1 }, 'move').to(this.$obj.find('.sprite'), 0.1, { x: 0 })
	      // .to(this.$objPerson, 0.1,{ rotationY: this.rev ? 0 : 180  })
	      .add(function () {
	        if (_this5.tapus == true) {
	          _this5.tapusTl.reverse();
	          _this5.tapusSwingTl.stop();
	        }
	      }).to({}, 0.1, {}).add(function () {
	        if (_this5.tapus == true) {
	          _this5.tapusTl.play();
	          _this5.tapusSwingTl.play();
	        }
	      }).to({}, 0.1, {});
	    }
	  }, {
	    key: 'createDetail',
	    value: function createDetail() {
	      var _this6 = this;
	
	      var cont = this.$tempPersonDetailMain;
	      if (this.id == '02') {
	        cont.find('.img1').remove();
	      } else {
	        cont.find('.img1').attr({ src: '/assets/img/person/detail/detail_' + this.id + '_01.png' });
	      }
	      cont.find('.img2').attr({ src: '/assets/img/person/detail/detail_' + this.id + '_02.png' });
	      cont.addClass('id' + this.id);
	      cont.find('.position').html(this.position);
	      cont.find('.name').text(this.nickName);
	      cont.find('.year').text(this.year + '年入社');
	
	      if (this.id != '02') {
	        var faqs = [];
	        $.each(this.faq, function (i, el) {
	          faqs.push('<dt>Q.' + (i + 1) + ' ' + el.q + '</dt><dd>' + el.a + '</dd>');
	        });
	        cont.find('#faqs').html(faqs);
	        cont.find('.year').show();
	      } else {
	        cont.find('#faqs').html(this.message);
	        cont.find('.year').hide();
	      }
	
	      cont.find('.thumbs').imagesLoaded(function () {
	        _this6.fadeSlider = cont.find('.thumbs').slick({
	          fade: true,
	          dots: false,
	          arrows: false,
	          // autoplay: true,
	          autoplaySpeed: 2000
	        });
	      });
	      // console.log(this.index);
	      // console.log(app.otherPeopleSlider);
	    }
	  }, {
	    key: 'setDetailPage',
	    value: function setDetailPage() {
	      var _this7 = this;
	
	      app.modals.$inner.scrollTop(0);
	      $('#personDetailMain').html(this.$tempPersonDetailMain);
	      setTimeout(function () {
	        app.otherPeopleSlider.slick('slickUnfilter');
	        app.otherPeopleSlider.slick('slickFilter', ':not(.id' + _this7.id + ')');
	        app.otherPeopleSlider.slick('setPosition');
	        _this7.fadeSlider.slick('setPosition');
	        _this7.fadeSlider.slick('slickGoTo', 0, true);
	        _this7.fadeSlider.slick('slickPlay');
	      }, 300);
	      // app.otherPeopleSlider.slick('slickGoTo', this.index, true);
	    }
	  }, {
	    key: 'otherPeople',
	    value: function otherPeople() {
	      var _this8 = this;
	
	      var cont = this.$tempOtherPeople.clone();
	      cont.addClass('id' + this.id);
	      cont.find('.thumb').attr({ src: '/assets/img/person/detail/thumb' + this.id + '.png' });
	      cont.find('.position').html(this.position);
	      cont.find('.name').text(this.nickName);
	      cont.find('.year').text(this.year + '年入社');
	      cont.on({
	        click: function click() {
	          if (app.modals.isOpen) {
	            _this8.change();
	          } else {
	            _this8.setDetailPage();
	            app.modals.open('detail');
	          }
	          return false;
	        }
	      });
	      return cont;
	    }
	  }]);
	
	  return Person;
	}();
	
	var Modals = function () {
	  function Modals() {
	    var _this9 = this;
	
	    _classCallCheck(this, Modals);
	
	    this.$modals = $('#modals');
	    this.$inner = $('#modals .inner');
	    this.$content = $('#modals .inner .modal');
	    this.$close = $('#modals #close,.btn.close');
	    this.isOpen = false;
	    this.current = '';
	
	    this.$modals.on("touchmove.noScroll", function (e) {
	      e.stopPropagation();
	    });
	
	    this.tl = new TimelineMax({
	      paused: true,
	      onReverseComplete: function onReverseComplete() {
	        TweenMax.set(_this9.$modals, { display: 'none' });
	        TweenMax.set(_this9.$content, { display: 'none' });
	        $(window).off('.noScroll');
	        TweenMax.set('#stage', { autoAlpha: 1 });
	      },
	      onStart: function onStart() {
	        TweenMax.set(_this9.$modals, { display: 'block' });
	        TweenMax.set('#stage', { autoAlpha: 0 });
	      }
	    });
	
	    $('.openModal').on({
	      click: function click(e) {
	        var id = $(e.currentTarget).data('modal');
	        _this9.open(id);
	      }
	    });
	
	    this.$close.on({
	      click: function click() {
	        _this9.close();
	      }
	    });
	
	    if (util.getUrlVars('m')) {
	      setTimeout(function () {
	        _this9.open(util.getUrlVars('m'));
	      }, 500);
	    }
	
	    this.$inner.on({
	      touchstart: function touchstart(e) {
	        _this9.scrollHeight = _this9.$content.outerHeight() - _this9.$inner.outerHeight();
	        _this9.startY = event.targetTouches[0].pageY;
	        // console.log(this.scrollHeight);
	      },
	      touchmove: function touchmove(e) {
	        _this9.moveY = event.targetTouches[0].pageY;
	        var scrTop = _this9.$inner.scrollTop();
	
	        if (scrTop <= 0 && _this9.startY < _this9.moveY) {
	          return false;
	        }
	        if (scrTop + 10 > _this9.scrollHeight && _this9.startY > _this9.moveY) {
	          return false;
	        }
	      }
	    });
	  }
	
	  _createClass(Modals, [{
	    key: 'open',
	    value: function open(id) {
	      if (!this.isOpen) {
	        this.tl.play();
	        $(window).on("touchmove.noScroll", function (e) {
	          e.preventDefault();
	        });
	        this.isOpen = true;
	        this.current = id;
	        this[id].start();
	        this.reminderTop = util.win.scrTop;
	        $('html').addClass('modal');
	
	        // } else {
	        //   this[id].change();
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.isOpen) {
	        app.modals.$inner.scrollTop(0);
	        this.tl.reverse();
	        this.isOpen = false;
	        this[this.current].close();
	        $('html').removeClass('modal');
	        $(window).scrollTop(this.reminderTop);
	      }
	    }
	  }]);
	
	  return Modals;
	}();
	
	var Modal = function () {
	  function Modal(id) {
	    _classCallCheck(this, Modal);
	
	    this.id = id;
	    this.$modal = $('#' + this.id);
	    this.$container = this.$modal.find('.container');
	  }
	
	  _createClass(Modal, [{
	    key: 'open',
	    value: function open() {
	      app.modals.open(this.id);
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      // TweenMax.set(this.$modal,{ display: 'block' });
	      TweenMax.fromTo(this.$modal, 0.5, { display: 'none', autoAlpha: 0 }, { display: 'block', autoAlpha: 1 });
	      app.modals.$inner.scrollTop(0);
	    }
	  }, {
	    key: 'close',
	    value: function close() {}
	  }]);
	
	  return Modal;
	}();
	
	var News = function (_Modal) {
	  _inherits(News, _Modal);
	
	  function News(id) {
	    _classCallCheck(this, News);
	
	    return _possibleConstructorReturn(this, (News.__proto__ || Object.getPrototypeOf(News)).call(this, id));
	  }
	
	  _createClass(News, [{
	    key: 'start',
	    value: function start() {
	      _get(News.prototype.__proto__ || Object.getPrototypeOf(News.prototype), 'start', this).call(this);
	      TweenMax.set(this.$container, { autoAlpha: 0 });
	      this.$container.find('#ajaxContent').empty();
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(postId) {
	      var _this11 = this;
	
	      // alert(postId)
	      $.ajax('/news/?p=' + postId).done(function (data) {
	        var $contents = $(data).find('#newsDetail').children();
	        new TimelineMax().add(function () {
	          $('#ajaxContent').html($contents);
	          app.modals.$inner.scrollTop(0);
	        }).to(_this11.$container, 0.3, { autoAlpha: 1 });
	
	        $contents.find('.prev_post>a, .next_post>a').on({
	          click: function click(e) {
	            var postId = $(e.currentTarget).data('postid');
	            new TimelineMax().to(_this11.$container, 0.3, { autoAlpha: 0 }).add(function () {
	              _this11.setContent(postId);
	            });
	
	            return false;
	          }
	        });
	      });
	    }
	  }]);
	
	  return News;
	}(Modal);
	
	var Welfare = function (_Modal2) {
	  _inherits(Welfare, _Modal2);
	
	  function Welfare(id) {
	    _classCallCheck(this, Welfare);
	
	    return _possibleConstructorReturn(this, (Welfare.__proto__ || Object.getPrototypeOf(Welfare)).call(this, id));
	  }
	
	  return Welfare;
	}(Modal);
	
	var ModalContact = function (_Modal3) {
	  _inherits(ModalContact, _Modal3);
	
	  function ModalContact(id) {
	    _classCallCheck(this, ModalContact);
	
	    var _this13 = _possibleConstructorReturn(this, (ModalContact.__proto__ || Object.getPrototypeOf(ModalContact)).call(this, id));
	
	    var rules = {
	      name: { required: true },
	      // company: { required: true },
	      // division: { required: true },
	      // phone: { required: true /* number: true, maxlength: 11, minlength: 10 */},
	      mail: { required: true, email: true },
	      inquiry: { required: true }
	      // upfile: { required: true },
	    };
	    _this13.form = new Form('formContact', '/php/api/contact.php', rules, _this13);
	    return _this13;
	  }
	
	  _createClass(ModalContact, [{
	    key: 'start',
	    value: function start() {
	      _get(ModalContact.prototype.__proto__ || Object.getPrototypeOf(ModalContact.prototype), 'start', this).call(this);
	      this.form.reset();
	    }
	  }]);
	
	  return ModalContact;
	}(Modal);
	
	var Entry = function (_Modal4) {
	  _inherits(Entry, _Modal4);
	
	  function Entry(id) {
	    _classCallCheck(this, Entry);
	
	    var _this14 = _possibleConstructorReturn(this, (Entry.__proto__ || Object.getPrototypeOf(Entry)).call(this, id));
	
	    var rules = {
	      occupation: { required: true },
	      name: { required: true },
	      kana: { required: true },
	      // age: { required: true },
	      // gender: { required: true },
	      // phone: { required: true /* number: true, maxlength: 11, minlength: 10 */},
	      mail: { required: true, email: true },
	      // zip: { required: true },
	      // address: { required: true },
	      // career: { required: true },
	      // file: { required: true, extension: 'jpg|png|gif' }
	      upfile1: { required: true },
	      upfile2: {},
	      upfile3: {},
	      note: {}
	    };
	    _this14.designer = ['artdirector', 'uiux-designer', 'animation-designer', '2dcg-effect-designer', '3dcg-motion-designer', '3dcg-effect-designer', '3dcg-model-designer', 'illustrator'];
	
	    _this14.form = new Form('formEntry', '/php/api/recruit.php', rules, _this14);
	    return _this14;
	  }
	
	  _createClass(Entry, [{
	    key: 'start',
	    value: function start() {
	      _get(Entry.prototype.__proto__ || Object.getPrototypeOf(Entry.prototype), 'start', this).call(this);
	      this.form.reset();
	      var pathname = location.pathname.split('/');
	      pathname = pathname[pathname.length - 2];
	      $('#entry select[name="occupation"] option').filter(function (index) {
	        return $(this).attr('name') == pathname;
	      }).prop('selected', true);
	
	      var isPortfolio = _.indexOf(this.designer, pathname) >= 0 ? true : false;
	      if (isPortfolio) {
	        this.form.$form.find('.portfolio').show();
	      } else {
	        this.form.$form.find('.portfolio').hide();
	      }
	    }
	  }]);
	
	  return Entry;
	}(Modal);
	
	var Detail = function (_Modal5) {
	  _inherits(Detail, _Modal5);
	
	  function Detail(id) {
	    _classCallCheck(this, Detail);
	
	    var _this15 = _possibleConstructorReturn(this, (Detail.__proto__ || Object.getPrototypeOf(Detail)).call(this, id));
	
	    var uniquePersons = _.unique(app.personsArr, 'id');
	
	    _this15.persons = uniquePersons;
	
	    var otherPeoples = [];
	    $.each(_this15.persons, function (i, el) {
	      // console.log(el.otherPeople());;
	      if (el.id == '00') {
	        return;
	      }
	      var cont = el.otherPeople();
	      otherPeoples.push(cont);
	    });
	    $('#otherPeople').html(otherPeoples);
	
	    app.otherPeopleSlider = $('#otherPeople').slick({
	      appendArrows: $('#otherPeople'),
	      prevArrow: '<div class="arrow prev"></div>',
	      nextArrow: '<div class="arrow next"></div>',
	      infinite: true,
	      slidesToShow: 4,
	      slidesToScroll: 4,
	      arrows: true,
	      draggable: false,
	      centerPadding: 0,
	      responsive: [{
	        breakpoint: 760,
	        settings: {
	          infinite: true,
	          speed: 200,
	          // centerMode: true
	          // centerPadding: 0,
	          draggable: true,
	          slidesToShow: 4,
	          slidesToScroll: 1,
	          swipeToSlide: true,
	          arrows: false
	        }
	      }]
	    });
	
	    return _this15;
	  }
	
	  _createClass(Detail, [{
	    key: 'start',
	    value: function start() {
	      _get(Detail.prototype.__proto__ || Object.getPrototypeOf(Detail.prototype), 'start', this).call(this);
	    }
	  }]);
	
	  return Detail;
	}(Modal);
	
	var Form = function () {
	  function Form(id, postUrl, rule, parent) {
	    var _this16 = this;
	
	    _classCallCheck(this, Form);
	
	    this.rule = rule;
	    this.postUrl = postUrl;
	    this.parent = parent;
	    this.$modalContaier = this.parent.$modal.find('.container');;
	    this.$form = $('#' + id);
	    this.$confirm = this.$form.siblings('.confirm');
	    this.$complete = this.$form.siblings('.complete');
	    //標準エラーメッセージの変更
	    $.extend($.validator.messages, {
	      email: '正しいメールアドレスを入力してください。',
	      required: 'この項目は必須となります。',
	      number: '半角数字で入力してください。',
	      minlength: '10桁～11桁の半角数字を入力してください',
	      maxlength: '10桁～11桁の半角数字を入力してください'
	    });
	    //バリデーションの追加
	    // $.validator.addMethod("zip", function(value, element) {
	    //   return this.optional(element) || /^[0-9\-]+$/.test(value);
	    // }, "半角数字で入力してください。");
	    // $.validator.addMethod('filesize', function(value, element, param) {
	    //     // param = size (en bytes)
	    //     // element = element to validate (<input>)
	    //     // value = value of the element (file name)
	    //     return this.optional(element) || (element.files[0].size <= param)
	    // });
	
	    //追加ルールの定義
	    // var methods = {
	    //   phone: function(value, element){
	    //     return this.optional(element) || /^\d{11}$|^\d{3}-\d{4}-\d{4}$/.test(value);
	    //   }
	    // };
	
	    //メソッドの追加
	    // $.each(methods, function(key) {
	    //   $.validator.addMethod(key, this);
	    // });
	
	    //入力項目の検証ルール定義
	
	
	    //入力項目ごとのエラーメッセージ定義
	    var messages = {
	      occupation: {
	        required: "選択してください。"
	      }
	    };
	
	    // form用event
	    this.$form.find('.submit').on({
	      click: function click() {
	        _this16.$form.submit();
	      }
	    });
	
	    this.$form.find('.back').on({
	      click: function click() {
	        app.modals.close();
	      }
	    });
	
	    this.$form.validate({
	      rules: this.rule,
	      messages: messages,
	      submitHandler: function submitHandler(form) {
	        _this16.formData = new FormData(_this16.$form.get(0));
	
	        _this16.confirm();
	
	        return false;
	      },
	
	      errorPlacement: function errorPlacement(error, element) {
	        error.appendTo(element.parents('dd').find('.err'));
	        // if (element.is('select')) {
	        //   error.appendTo(element.parent().parent('.err'));
	        // } else if (element.is(':radio')) {
	        //   error.appendTo(element.parents('dd').find('.err'));
	        // } else {
	        //   error.appendTo(element.parents('dd').find('.err'));
	        // }
	      }
	    });
	
	    var $file = this.$form.find('input.upfile');
	    $.each($file, function (i, el) {
	      var $this = $(el);
	      var $parent = $this.parents('dd');
	      $this.on({
	        change: function change() {
	          var val = $this.get(0).files[0];
	          var name = $this.attr('name');
	          if (val) {
	            _this16.$confirm.find('.' + name).text(val.name);
	            $parent.find('.filename').text(val.name);
	            $parent.find('.attachText').text('ファイルの添付をやり直す');
	          } else {
	            _this16.$confirm.find('.' + name).text('');
	            $parent.find('.filename').text('選択されていません');
	            $parent.find('.attachText').text('ファイルを添付する');
	          }
	        }
	      });
	    });
	
	    // confirm event
	    this.$confirm.find('.back').on({
	      click: function click() {
	        _this16.form();
	      }
	    });
	    this.$confirm.find('.submit').on({
	      click: function click() {
	        _this16.send();
	      }
	    });
	  }
	
	  _createClass(Form, [{
	    key: 'reset',
	    value: function reset() {
	      this.$form.get(0).reset();
	      this.$form.find('input.upfile').change();
	      app.modals.$inner.scrollTop(0);
	      TweenMax.set([this.$confirm, this.$complete], { autoAlpha: 0, display: 'none' });
	      TweenMax.set(this.$form, { autoAlpha: 1, display: 'block' });
	    }
	  }, {
	    key: 'form',
	    value: function form() {
	      this.change(this.$confirm, this.$form);
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      var _this17 = this;
	
	      // for (var [key, val] of this.formData.entries()) {
	      //   if ( key == 'upfile' || key == 'upfile1' || key == 'upfile2' || key == 'upfile3' ){
	      //     this.$confirm.find(`.${key}`).text(val.name);
	      //   } else {
	      //     this.$confirm.find(`.${key}`).text(val);
	      //   }
	      // }
	
	      //サファリなどが対応してないのでこちらの形に変更
	      this.formDataText = _.chain(this.$form.serializeArray()).map(function (input) {
	        return [input.name, input.value];
	      }).object().value();
	
	      $.each(this.formDataText, function (key, val) {
	        _this17.$confirm.find('.' + key).text(val);
	      });
	
	      this.change(this.$form, this.$confirm);
	    }
	  }, {
	    key: 'send',
	    value: function send() {
	      var _this18 = this;
	
	      // console.log(this.postUrl,this.formData);
	      $.ajax(this.postUrl, {
	        type: 'post',
	        dataType: 'json',
	        data: this.formData,
	        processData: false,
	        contentType: false
	      }).done(function (json) {
	        // console.log(json);
	        if (json.result == true) {
	          _this18.complete();
	        }
	      }).fail(function () {
	        if (location.href.indexOf('192.168') != -1) {
	          _this18.complete();
	        } else {
	          alert('失敗');
	        }
	      });
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.change(this.$confirm, this.$complete);
	    }
	  }, {
	    key: 'change',
	    value: function change(hide, show) {
	      var hideCont = hide;
	      var showCont = show;
	      new TimelineMax().to(hideCont, 0.3, { autoAlpha: 0 }).add(function () {
	        app.modals.$inner.scrollTop(0);
	      }).set(showCont, { display: 'block' }).set(hideCont, { display: 'none' }).to(showCont, 0.3, { autoAlpha: 1 });
	    }
	  }]);
	
	  return Form;
	}();
	
	var Ticker = function () {
	  function Ticker() {
	    _classCallCheck(this, Ticker);
	
	    var speed = 8;
	    var $wrapper = $('#newsTicker');
	    var $texts = $wrapper.find('ul');
	    var $text = $texts.find('li');
	    var last = $text.first().clone();
	    $texts.append(last);
	    var width = last.get(0).offsetLeft;
	    this.tl = new TimelineMax({
	      paused: true
	    }).to($texts, width / 750 * speed, {
	      x: -width,
	      repeat: -1,
	      ease: Power0.easeNone
	    });
	  }
	
	  _createClass(Ticker, [{
	    key: 'move',
	    value: function move() {
	      this.tl.play();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.tl.stop();
	    }
	  }]);
	
	  return Ticker;
	}();
	
	var ScrollBar = function () {
	  function ScrollBar(id) {
	    var _this19 = this;
	
	    _classCallCheck(this, ScrollBar);
	
	    this.$container = $(id);
	    this.$rail = $('#scrollRail');
	    this.$bar = $('#scrollBar');
	    this.offsetTop = 50;
	    this.$rail.show();
	    Draggable.create(this.$bar, {
	      type: "y",
	      edgeResistance: 1,
	      bounds: this.$rail,
	      cursor: 'pointer',
	      onDrag: function onDrag() {
	        _this19.dragUpdate(_this19.draggable.y);
	      }
	    });
	    this.draggable = Draggable.get(this.$bar);
	    this.draggable.update();
	  }
	
	  _createClass(ScrollBar, [{
	    key: 'resize',
	    value: function resize(containerH, scrTop, scale) {
	      this.scale = scale;
	      this.containerH = containerH;
	      this.railHeight = util.win.h - this.offsetTop;
	      this.railRatio = this.railHeight / containerH;
	      this.barH = (util.win.h - this.offsetTop) * this.railRatio / app.verticalScaleY;
	      TweenMax.set(this.$rail, { top: this.offsetTop });
	      TweenMax.set(this.$bar, { height: this.barH });
	
	      // TweenMax.set(this.$bar, { height: conten})
	      // console.log(containerH,scrTop);
	    }
	  }, {
	    key: 'update',
	    value: function update(scrollTop) {
	      this.top = scrollTop * this.railRatio / app.verticalScaleY;
	      TweenMax.set(this.$bar, { y: this.top });
	    }
	  }, {
	    key: 'dragUpdate',
	    value: function dragUpdate(y) {
	      var scrollTop = this.draggable.y / this.railRatio * app.verticalScaleY;
	      $('#surface').scrollTop(scrollTop);
	    }
	  }, {
	    key: 'drag2',
	    value: function drag2() {
	      var _this20 = this;
	
	      this.x, this.y;
	      this.$bar.on({
	        mousedown: function mousedown(e) {
	          e.preventDefault();
	          _this20.y = e.clientY;
	          _this20.isDrag = true;
	          // console.log(this.y);
	        },
	        mousemove: function mousemove(e) {
	          e.preventDefault();
	          if (_this20.isDrag == true) {
	            _this20.move = _this20.y - e.clientY;
	            $('#surface').scrollTop(-_this20.move);
	            TweenMax.set(_this20.$bar, { y: -_this20.move });
	            // console.log(this.move);
	          }
	        },
	        mouseup: function mouseup(e) {
	          e.preventDefault();
	          _this20.isDrag = false;
	          // console.log("up");
	          // this.move = 0;
	          // this.y = 0;
	
	        }
	      });
	    }
	  }]);
	
	  return ScrollBar;
	}();
	
	$(function () {
	  app.main = new Main();
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	var app = window.app || {};
	window.app = app;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	app.positions = [
	  {
	    order: 0,
	    rev: false,
	    left: -59,
	    // top: 227,
	    defaultTop: [ 0.24, 0.14 ],
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 1,
	    rev: true,
	    left: 258,
	    // top: 450,
	    defaultTop: [ 0.30, 0.21 ],
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 2,
	    rev: false,
	    left: -228,
	    // top: 493,
	    defaultTop: [ 0.35, 0.32 ],
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 3,
	    rev: true,
	    left: 60,
	    // top: 543,
	    defaultTop: [ 0.45, 0.43 ],
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 4,
	    rev: false,
	    left: -225,
	    // top: 910,
	    defaultTop: 0.75,
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 5,
	    rev: true,
	    left: 100,
	    defaultTop: [ 0.87, 0.85 ],
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 6,
	    rev: true,
	    left: 238,
	    // top: 15,
	    defaultTop: 0.90,
	    parent: 'main',
	    scrSync: false,
	    tapus: true
	  },{
	    order: 7,
	    rev: false,
	    left: -61,
	    // top: 1090,
	    defaultTop: 0.96,
	    parent: 'main',
	    scrSync: false,
	  },{
	    order: 8,
	    rev: false,
	    left: -62,
	    top: -100,
	    parent: 'newsIndex',
	    scrSync: true,
	  },{
	    order: 9,
	    rev: false,
	    left: -190,
	    top: -43,
	    parent: 'newsIndex',
	    scrSync: true,
	  },{
	    order: 10,
	    rev: true,
	    left: 224,
	    top: 90,
	    parent: 'newsIndex',
	    scrSync: true,
	  },{
	    order: 11,
	    rev: false,
	    left: -250,
	    top: 343,
	    parent: 'newsIndex',
	    scrSync: true,
	  },{
	    order: 12,
	    rev: false,
	    left: -55,
	    top: -100,
	    parent: 'product',
	    scrSync: true,
	  },{
	    order: 13,
	    rev: false,
	    left: -221,
	    top: 132,
	    parent: 'product',
	    scrSync: true,
	  },{
	    order: 14,
	    rev: true,
	    left: 189,
	    top: 323,
	    // defaultTop: 0.26,
	    parent: 'product',
	    scrSync: true,
	  },{
	    order: 15,
	    rev: true,
	    left: 211,
	    top: 1430,
	    parent: 'product',
	    scrSync: true,
	  },{
	    order: 16,
	    rev: false,
	    left: -240,
	    top: -231,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 17,
	    rev: true,
	    left: 152,
	    top: 34,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 18,
	    rev: true,
	    left: 207,
	    top: 251,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 19,
	    rev: false,
	    left: -255,
	    top: 336,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 20,
	    rev: false,
	    left: -255,
	    top: 1740,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 21,
	    rev: true,
	    left: 249,
	    top: 1870,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 22,
	    rev: false,
	    left: -217,
	    top: 2200,
	    parent: 'recruit',
	    scrSync: true,
	  },{
	    order: 23,
	    rev: false,
	    left: -79,
	    top: -184,
	    parent: 'about',
	    scrSync: true,
	  },{
	    order: 24,
	    rev: true,
	    left: 158,
	    top: -50,
	    parent: 'about',
	    scrSync: true,
	  },{
	    order: 25,
	    rev: false,
	    left: -227,
	    top: 90,
	    parent: 'about',
	    scrSync: true,
	  },{
	    order: 26,
	    rev: true,
	    left: 218,
	    top: 481,
	    parent: 'about',
	    scrSync: true,
	  },{
	    order: 27,
	    rev: true,
	    left: 217,
	    top: 2040,
	    parent: 'about',
	    scrSync: true,
	  },{
	    order: 28,
	    rev: false,
	    left: -120,
	    top: -70,
	    parent: 'contact',
	    scrSync: true,
	  },{
	    order: 29,
	    rev: true,
	    left: 140,
	    top: 70,
	    parent: 'contact',
	    scrSync: true,
	  },{
	    order: 30,
	    rev: false,
	    left: -200,
	    top: 200,
	    parent: 'contact',
	    scrSync: true,
	  },{
	    order: 31,
	    rev: true,
	    left: 125,
	    top: 1087,
	    parent: 'contact',
	    scrSync: true,
	  },{
	    order: 32,
	    rev: false,
	    left: -129,
	    top: 1122,
	    parent: 'contact',
	    scrSync: true,
	  },{
	    order: 33,
	    rev: false,
	    left: -206,
	    top: 548,
	    parent: 'footer',
	    scrSync: true,
	    defaultPos: 1,
	    tapus: true
	  },{
	    order: 34,
	    rev: true,
	    left: 198,
	    top: 630,
	    parent: 'footer',
	    scrSync: true,
	    defaultPos: 1,
	  }
	];

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js